// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingItem-bookingCardItemContainer-ExCyf {
    border: 1px solid var(--primary-border);
    padding: 18px;
    border-radius: var(--radius-3);
    background: var(--background-primary);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 18px;
    grid-gap: 18px;
}

.BookingItem-bookingCardItemImgContainer-bXYqU {
    position: relative;
    width: 100%;
    max-width: 144px;
    height: 144px;
    border-radius: 0 var(--radius-2) 0 var(--radius-2);
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.BookingItem-bookingCardItemImgContainer-bXYqU img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
}

.BookingItem-bookingCardItemInfoContainer-Q80U_ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    grid-gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

.BookingItem-bookingCardItemInfoRsContainer-HzIuz {
    background: var(--background-secondary);
    padding: 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    text-align: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -ms-flex-negative: 0;
        flex-shrink: 0;
    border-radius: var(--radius-2);
    max-width: 254px;
}

.BookingItem-bookingCardItemInfoTooltipContainer-b3u3E {
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    color: var(--primary-foreground);
    margin-bottom: 6px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
        -ms-flex-align: baseline;
            align-items: baseline;
    gap: 6px;
    grid-gap: 6px;
}

.BookingItem-bookingCardItemInfoTooltipContainer-b3u3E img {
    position: relative;
    top: 2px;
    width: 16px;
    height: 16px;
}

.BookingItem-bookingCardItemInfoTypeLink-D4ZVV,
.BookingItem-bookingCardItemInfoTypeLink-D4ZVV:hover,
.BookingItem-bookingCardItemInfoTypeLink-D4ZVV:focus {
    font-size: 16px;
    font-weight: 700;
    line-height: 26px;
    color: var(--primary-link-foreground);
    text-decoration: unset;
    cursor: pointer;
}

.BookingItem-bookingCardItemInfoIdBox-O5gNu {
    font-size: 16px;
    line-height: 26px;
    font-weight: 700;
    padding: 3px 12px;
    background: var(--opt-bg);
    border-radius: var(--radius-5);
    color: var(--common-primary-black-foreground);
}

.BookingItem-bookingCardItemInfoLink-nENV5 {
    margin-top: 12px;
    margin-bottom: 0;
}

.BookingItem-bookingCardItemInfoType-cUFwc {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
        -ms-flex-align: baseline;
            align-items: baseline;
    gap: 6px;
    grid-gap: 6px;
    margin-bottom: 6px;
}

.BookingItem-bookingCardItemInfoType-cUFwc img {
    position: relative;
    top: 3px;
    width: 18px;
    height: 18px;
}

.BookingItem-bookingCardItemInfoLocationText-qzuoj {
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    color: var(--primary-foreground);
}

.BookingItem-bookingCardItemInfoLsContainer-ZsHBj {
    text-align: start;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

.BookingItem-bookingStatusText-wyrMr {
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
}

.BookingItem-commonCardLinkIcon14-v5g4J {
    width: 14px;
    height: 14px;
}

@media (max-width: 1199px) and (min-width: 992px) {
    .BookingItem-bookingCardItemImgContainer-bXYqU {
        max-width: 110px;
        height: 110px;
    }
}

@media (max-width: 991px) {
    .BookingItem-bookingCardItemContainer-ExCyf {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
    }

    .BookingItem-bookingCardItemImgContainer-bXYqU {
        max-width: 100%;
    }

    .BookingItem-bookingCardItemInfoContainer-Q80U_ {
        max-width: 100%;
        width: 100%;
    }
}

@media (max-width: 991px) and (min-width: 768px) {
    .BookingItem-bookingCardItemImgContainer-bXYqU {
        height: 200px;
    }
}

@media (max-width: 767px) {
    .BookingItem-bookingCardItemInfoContainer-Q80U_ {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
        width: 100%;
    }

    .BookingItem-bookingCardItemInfoRsContainer-HzIuz {
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/UpcomingBooking/BookingItem/BookingItem.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,aAAa;IACb,8BAA8B;IAC9B,qCAAqC;IACrC,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kDAAkD;IAClD,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,oBAAiB;OAAjB,iBAAiB;IACjB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,kBAAkB;IAClB,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,oBAAc;QAAd,cAAc;IACd,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,2BAAqB;QAArB,wBAAqB;YAArB,qBAAqB;IACrB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qCAAqC;IACrC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,2BAAqB;QAArB,wBAAqB;YAArB,qBAAqB;IACrB,QAAQ;IACR,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;IACjB;AACJ;;AAGA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,0BAAoB;YAApB,uBAAoB;gBAApB,oBAAoB;QACpB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".bookingCardItemContainer {\n    border: 1px solid var(--primary-border);\n    padding: 18px;\n    border-radius: var(--radius-3);\n    background: var(--background-primary);\n    display: flex;\n    align-items: flex-start;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.bookingCardItemImgContainer {\n    position: relative;\n    width: 100%;\n    max-width: 144px;\n    height: 144px;\n    border-radius: 0 var(--radius-2) 0 var(--radius-2);\n    flex-shrink: 0;\n}\n\n.bookingCardItemImgContainer img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: inherit;\n    object-fit: cover;\n    object-position: center;\n}\n\n.bookingCardItemInfoContainer {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    grid-gap: 12px;\n    flex-grow: 1;\n}\n\n.bookingCardItemInfoRsContainer {\n    background: var(--background-secondary);\n    padding: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    flex-direction: column;\n    flex-shrink: 0;\n    border-radius: var(--radius-2);\n    max-width: 254px;\n}\n\n.bookingCardItemInfoTooltipContainer {\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 28px;\n    color: var(--primary-foreground);\n    margin-bottom: 6px;\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n    grid-gap: 6px;\n}\n\n.bookingCardItemInfoTooltipContainer img {\n    position: relative;\n    top: 2px;\n    width: 16px;\n    height: 16px;\n}\n\n.bookingCardItemInfoTypeLink,\n.bookingCardItemInfoTypeLink:hover,\n.bookingCardItemInfoTypeLink:focus {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 26px;\n    color: var(--primary-link-foreground);\n    text-decoration: unset;\n    cursor: pointer;\n}\n\n.bookingCardItemInfoIdBox {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 700;\n    padding: 3px 12px;\n    background: var(--opt-bg);\n    border-radius: var(--radius-5);\n    color: var(--common-primary-black-foreground);\n}\n\n.bookingCardItemInfoLink {\n    margin-top: 12px;\n    margin-bottom: 0;\n}\n\n.bookingCardItemInfoType {\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n    grid-gap: 6px;\n    margin-bottom: 6px;\n}\n\n.bookingCardItemInfoType img {\n    position: relative;\n    top: 3px;\n    width: 18px;\n    height: 18px;\n}\n\n.bookingCardItemInfoLocationText {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n}\n\n.bookingCardItemInfoLsContainer {\n    text-align: start;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    flex-grow: 1;\n}\n\n.bookingStatusText {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 26px;\n}\n\n.commonCardLinkIcon14 {\n    width: 14px;\n    height: 14px;\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n    .bookingCardItemImgContainer {\n        max-width: 110px;\n        height: 110px;\n    }\n}\n\n\n@media (max-width: 991px) {\n    .bookingCardItemContainer {\n        flex-direction: column;\n    }\n\n    .bookingCardItemImgContainer {\n        max-width: 100%;\n    }\n\n    .bookingCardItemInfoContainer {\n        max-width: 100%;\n        width: 100%;\n    }\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n    .bookingCardItemImgContainer {\n        height: 200px;\n    }\n}\n\n@media (max-width: 767px) {\n    .bookingCardItemInfoContainer {\n        flex-direction: column;\n        align-items: stretch;\n        width: 100%;\n    }\n\n    .bookingCardItemInfoRsContainer {\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookingCardItemContainer": `BookingItem-bookingCardItemContainer-ExCyf`,
	"bookingCardItemImgContainer": `BookingItem-bookingCardItemImgContainer-bXYqU`,
	"bookingCardItemInfoContainer": `BookingItem-bookingCardItemInfoContainer-Q80U_`,
	"bookingCardItemInfoRsContainer": `BookingItem-bookingCardItemInfoRsContainer-HzIuz`,
	"bookingCardItemInfoTooltipContainer": `BookingItem-bookingCardItemInfoTooltipContainer-b3u3E`,
	"bookingCardItemInfoTypeLink": `BookingItem-bookingCardItemInfoTypeLink-D4ZVV`,
	"bookingCardItemInfoIdBox": `BookingItem-bookingCardItemInfoIdBox-O5gNu`,
	"bookingCardItemInfoLink": `BookingItem-bookingCardItemInfoLink-nENV5`,
	"bookingCardItemInfoType": `BookingItem-bookingCardItemInfoType-cUFwc`,
	"bookingCardItemInfoLocationText": `BookingItem-bookingCardItemInfoLocationText-qzuoj`,
	"bookingCardItemInfoLsContainer": `BookingItem-bookingCardItemInfoLsContainer-ZsHBj`,
	"bookingStatusText": `BookingItem-bookingStatusText-wyrMr`,
	"commonCardLinkIcon14": `BookingItem-commonCardLinkIcon14-v5g4J`
};
module.exports = ___CSS_LOADER_EXPORT___;
